// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__rvb11","colCheckbox":"styles_colCheckbox__28g1w"};